import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button, Divider, Grid, Paper, Typography } from "@mui/material";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import ContactPhoneOutlinedIcon from "@mui/icons-material/ContactPhoneOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import { uploadDocument, viewDocument } from "../utiles/DocumentService";
import CustomLoader from "../static/CustomLoader";

const NAVY = "#123B5D";
const NAVY_DARK = "#0E304B";
const BORDER = "#C9D7E3";
const MUTED = "#64748B";
const SURFACE = "#F7FAFC";
const ERROR = "#D32F2F";
const SUCCESS = "#22965F";

const fieldSx = (hasError) => ({
  "& .MuiOutlinedInput-root": {
    minHeight: 40,
    borderRadius: "7px",
    backgroundColor: "#FFFFFF",
    fontSize: 13.5,
    color: "#243746",
    "& fieldset": {
      borderColor: hasError ? ERROR : BORDER,
    },
    "&:hover fieldset": {
      borderColor: hasError ? ERROR : "#9FB2C2",
    },
    "&.Mui-focused fieldset": {
      borderColor: hasError ? ERROR : NAVY,
      borderWidth: 1.5,
    },
  },
  "& .MuiInputBase-input": {
    padding: "9px 11px",
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#94A3B8",
    opacity: 1,
    fontSize: 13.5,
  },
});

const Field = ({
  label,
  required = false,
  value,
  onChange,
  onFocus,
  onMouseDown,
  placeholder,
  type = "text",
  error,
  disabled = false,
}) => (
  <Box>
    <Typography
      component="label"
      sx={{
        display: "block",
        mb: 0.6,
        fontSize: 12,
        fontWeight: 700,
        color: "#33485C",
      }}
    >
      {label}
      {required && (
        <Box
          component="span"
          sx={{
            ml: 0.25,
            color: ERROR,
          }}
        >
          *
        </Box>
      )}
    </Typography>
    <Box
      component="input"
      type={type}
      value={value ?? ""}
      placeholder={placeholder}
      disabled={disabled}
      onChange={onChange}
      onFocus={onFocus}
      onMouseDown={onMouseDown}
      sx={{
        width: "100%",
        height: 40,
        boxSizing: "border-box",
        px: 1.4,
        border: `1px solid ${error ? ERROR : BORDER}`,
        borderRadius: "7px",
        outline: "none",
        backgroundColor: disabled ? "#EEF2F6" : "#FFFFFF",
        color: "#243746",
        fontSize: 13.5,
        fontFamily: "inherit",
        transition: "border-color 0.15s ease, box-shadow 0.15s ease",
        "&:hover": {
          borderColor: error ? ERROR : "#9FB2C2",
        },
        "&:focus": {
          borderColor: error ? ERROR : NAVY,
          boxShadow: `0 0 0 2px ${
            error ? "rgba(211,47,47,0.08)" : "rgba(18,59,93,0.08)"
          }`,
        },
        "&::placeholder": {
          color: "#94A3B8",
          opacity: 1,
        },
      }}
    />
    {error && (
      <Typography
        sx={{
          mt: 0.45,
          fontSize: 11,
          lineHeight: 1.3,
          color: ERROR,
        }}
      >
        {error}
      </Typography>
    )}
  </Box>
);

const Section = ({ icon, title, subtitle, children }) => (
  <Paper
    elevation={0}
    sx={{
      border: `1px solid ${BORDER}`,
      borderRadius: "10px",
      overflow: "hidden",
      backgroundColor: "#FFFFFF",
    }}
  >
    <Box
      sx={{
        px: 1.75,
        py: 1.15,
        display: "flex",
        alignItems: "center",
        gap: 1,
        backgroundColor: "#EEF5FB",
        borderBottom: `1px solid ${BORDER}`,
      }}
    >
      <Box
        sx={{
          width: 34,
          height: 34,
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#DCEBFA",
          color: NAVY,
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography
          sx={{
            fontSize: 13.5,
            fontWeight: 700,
            color: NAVY,
            lineHeight: 1.2,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            sx={{
              mt: 0.25,
              fontSize: 10.5,
              color: MUTED,
              lineHeight: 1.3,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
    <Box sx={{ p: 1.75 }}>{children}</Box>
  </Paper>
);

const Oraganization = ({ selectedId, mode, onHide, setRefresh }) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");

  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const [attachedFile, setAttachedFile] = useState(null);
  const [uploadedFilePath, setUploadedFilePath] = useState("");
  const [previewURL, setPreviewURL] = useState("");
  const [name, setName] = useState("");
  const [addressline1, setAddressLine1] = useState("");
  const [addressline2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [dist, setDist] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [pincode, setPincode] = useState("");
  const [trust, setTrust] = useState("");
  const [establishmentyear, setEstablishmentYear] = useState("");
  const [type, setType] = useState("");
  const [contact, setcontact] = useState("");
  const [emailid, setEmailid] = useState("");
  const [errors, setErrors] = useState({});
  const [validation, setValidation] = useState(false);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);

  const orgcode = localStorage.getItem("custCode") || "ptw";
  const envCode = localStorage.getItem("envcode") || "Prod";

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  const currentYear = new Date().getFullYear();
  const startYear = 1900;

  const years = Array.from(
    new Array(currentYear - startYear + 1),
    (val, index) => startYear + index,
  );

  const fetchEmployeeImage = async (empCode, logoName) => {
    setLoading(true);

    try {
      const folderPath = `${orgcode}/org_${empCode}`;

      const response = await viewDocument({
        projectCode: "Ptw",
        envCode,
        folderPath,
        fileName: logoName,
      });

      if (response.cd === 1) {
        return "";
      }

      if (response) {
        const mimeType = logoName.toLowerCase().endsWith(".pdf")
          ? "application/pdf"
          : "image/jpeg";

        return `data:${mimeType};base64,${response}`;
      }

      return "";
    } catch (err) {
      console.error("Failed to fetch image:", err);
      return "";
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedId !== "") {
      axios
        .get(`${apiUrl}organization/id/${selectedId}`, { headers })
        .then((response) => {
          if (response.data.cd === 1) {
            alert(response.data.description);
          } else {
            setId(response.data.id);
            setCode(response.data.code);
            setName(response.data.name);
            setAddressLine1(response.data.addressline1);
            setAddressLine2(response.data.addressline2);
            setCity(response.data.city);
            setDist(response.data.dist);
            setState(response.data.state);
            setCountry(response.data.country);
            setPincode(response.data.pin);
            setTrust(response.data.trust);
            setEstablishmentYear(response.data.establishmentyear);
            setcontact(response.data.contact);
            setType(response.data.type);
            setEmailid(response.data.emailid);
            setUploadedFilePath(response.data.logo);

            if (response.data.logo && response.data.code) {
              fetchEmployeeImage(response.data.code, response.data.logo).then(
                (url) => {
                  if (url) {
                    setPreviewURL(url);
                  }
                },
              );
            }

            setImage(response.data.imageString);
          }
        })
        .catch((error) => {
          alert(error.message);
        });
    }
  }, []);

  function clearFields() {
    setId("");
    setCode("");
    setTrust("");
    setType("");
    setName("");
    setAddressLine1("");
    setAddressLine2("");
    setCity("");
    setDist("");
    setState("");
    setCountry("");
    setPincode("");
    setEstablishmentYear("");
    setcontact("");
    setEmailid("");
    setAttachedFile(null);
    setUploadedFilePath("");
    setPreviewURL("");
    setImage(null);
    setErrors({});
  }

  const handleFocus = (field) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: "",
    }));
  };

  const validateFields = () => {
    let errors = {};

    const isNumeric = (value) => !isNaN(value) && !isNaN(parseFloat(value));

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!name) errors.name = "Name is required...";

    if (!addressline1) errors.addressline1 = "Addressline1 is required...";

    if (!city) errors.city = "City is required...";

    if (!country) errors.country = "Country is required...";

    if (!isNumeric(contact)) {
      errors.contact = "Contact Number is required and must be numeric...";
    } else if (String(contact).length !== 10) {
      errors.contact = "Contact number must be exactly 10 digits long.";
    }

    if (!emailid) {
      errors.emailid = "Email is required...";
    } else if (!isValidEmail(emailid)) {
      errors.emailid = "Please enter a valid email address.";
    }

    return errors;
  };

  const handlesubmit = async () => {
    const fieldErrors = validateFields();

    setErrors(fieldErrors);

    if (Object.keys(fieldErrors).length > 0) {
      toast.warning("Please correct all required input fields.");
      return;
    }

    const payload = {
      id: id,
      code: code,
      type: type,
      name: name,
      addressline1: addressline1,
      addressline2: addressline2,
      city: city,
      dist: dist,
      state: state,
      country: country,
      pin: pincode,
      trust: trust,
      establishmentyear: establishmentyear,
      contact: contact,
      emailid: emailid,
      logo: uploadedFilePath,
    };

    try {
      let response;

      setLoading(true);

      if (mode === "A") {
        response = await axios.post(
          `${apiUrl}organization`,
          JSON.stringify(payload),
          { headers },
        );
      } else {
        response = await axios.put(
          `${apiUrl}organization`,
          JSON.stringify(payload),
          { headers },
        );
      }

      if (response.data.cd === 1) {
        toast.error(response.data.description);

        if (mode !== "A") {
          setTitle("⚠️ Failed");
          setSucessMessage(response.data.description);
          setShowSucessModal(true);
        }

        setLoading(false);
      } else {
        toast.success(response.data.description);

        onHide();
        setRefresh(true);

        if (mode !== "A") {
          setTitle("✔️ Success");
          setSucessMessage(response.data.description);
          setShowSucessModal(true);
        }

        setLoading(false);
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      setLoading(false);
    }
  };

  const logoAction = async (e) => {
    const file = e.target.files[0];

    if (file && file.size < 5 * 1024 * 1024) {
      setAttachedFile(file);
      setPreviewURL(URL.createObjectURL(file));
    } else {
      toast.warning("The file exceeds the size limit and was not added.");
    }
  };

  const handleUpload = async () => {
    if (!attachedFile) {
      toast.warning("No file selected.");
      return;
    }

    const folderPath = `${orgcode}/org_${code}`;
    const maxRetries = 3;

    setLoading(true);

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const uploadRes = await uploadDocument({
          file: attachedFile,
          projectCode: "Ptw",
          envCode,
          folderPath,
        });

        if (uploadRes?.cd === 1) {
          setLoading(false);
          return;
        }

        toast.success("Upload successful!");

        setUploadedFilePath(uploadRes);
        break;
      } catch (error) {
        console.warn(`Attempt ${attempt} failed`, error);

        if (attempt === maxRetries) {
          toast.error("Upload failed after multiple attempts.");
        } else {
          await new Promise((resolve) => setTimeout(resolve, 2000 * attempt));
        }
      }
    }

    setLoading(false);
  };

  const logoPreview =
    mode === "U"
      ? previewURL
      : image
        ? `data:image/png;base64,${image}`
        : previewURL;

  return (
    <>
      <SucessModal
        show={ShowSucessModal}
        onClose={handleCloseSucessModal}
        headerText={titile}
        message={SucessMessage}
      />

      <Box
        sx={{
          width: "100%",
          backgroundColor: SURFACE,
          p: {
            xs: 1,
            sm: 1.5,
          },
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gap: 1.5,
          }}
        >
          <Section
            icon={<BusinessOutlinedIcon fontSize="small" />}
            title="Organization Details"
            subtitle="Basic company identification"
          >
            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Field
                  label="Organization Name"
                  required
                  value={name}
                  placeholder="Organization Name"
                  error={errors.name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setValidation(false);
                  }}
                  onMouseDown={() => setValidation(true)}
                  onFocus={() => handleFocus("name")}
                />
              </Grid>
            </Grid>
          </Section>

          <Section
            icon={<LocationOnOutlinedIcon fontSize="small" />}
            title="Address"
            subtitle="Registered office location"
          >
            <Grid container spacing={1.5}>
              <Grid item xs={12} md={6}>
                <Field
                  label="Address Line 1"
                  required
                  value={addressline1}
                  placeholder="Address Line 1"
                  error={errors.addressline1}
                  onChange={(e) => {
                    setAddressLine1(e.target.value);
                    setValidation(false);
                  }}
                  onMouseDown={() => setValidation(true)}
                  onFocus={() => handleFocus("addressline1")}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  label="Address Line 2"
                  value={addressline2}
                  placeholder="Address Line 2"
                  error={
                    validation && !addressline2
                      ? "Please enter a valid Address Line 2"
                      : ""
                  }
                  onChange={(e) => {
                    setAddressLine2(e.target.value);
                    setValidation(false);
                  }}
                  onMouseDown={() => setValidation(true)}
                  onFocus={() => handleFocus("addressline1")}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  label="Pincode"
                  value={pincode}
                  placeholder="Pin Code"
                  error={errors.pincode}
                  onChange={(e) => {
                    setPincode(e.target.value);
                    setValidation(false);
                  }}
                  onMouseDown={() => setValidation(true)}
                  onFocus={() => handleFocus("pincode")}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  label="City"
                  required
                  value={city}
                  placeholder="City"
                  error={errors.city}
                  onChange={(e) => {
                    setCity(e.target.value);
                    setValidation(false);
                  }}
                  onMouseDown={() => setValidation(true)}
                  onFocus={() => handleFocus("city")}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  label="District"
                  value={dist}
                  placeholder="District"
                  error={errors.dist}
                  onChange={(e) => {
                    setDist(e.target.value);
                    setValidation(false);
                  }}
                  onMouseDown={() => setValidation(true)}
                  onFocus={() => handleFocus("dist")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Field
                  label="State"
                  value={state}
                  placeholder="State"
                  error={errors.state}
                  onChange={(e) => {
                    setState(e.target.value);
                    setValidation(false);
                  }}
                  onMouseDown={() => setValidation(true)}
                  onFocus={() => handleFocus("state")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Field
                  label="Country"
                  required
                  value={country}
                  placeholder="Country"
                  error={errors.country}
                  onChange={(e) => {
                    setCountry(e.target.value);
                    setValidation(false);
                  }}
                  onMouseDown={() => setValidation(true)}
                  onFocus={() => handleFocus("country")}
                />
              </Grid>
            </Grid>
          </Section>

          <Section
            icon={<ContactPhoneOutlinedIcon fontSize="small" />}
            title="Business & Contact"
            subtitle="Organization contact and business information"
          >
            <Grid container spacing={1.5}>
              <Grid item xs={12} md={4}>
                <Box>
                  <Typography
                    component="label"
                    sx={{
                      display: "block",
                      mb: 0.6,
                      fontSize: 12,
                      fontWeight: 700,
                      color: "#33485C",
                    }}
                  >
                    Establishment Year
                  </Typography>
                  <Box
                    component="select"
                    value={establishmentyear}
                    onChange={(e) => {
                      setEstablishmentYear(e.target.value);
                      setValidation(false);
                    }}
                    onMouseDown={() => setValidation(true)}
                    onFocus={() => handleFocus("establishmentyear")}
                    sx={{
                      width: "100%",
                      height: 40,
                      px: 1.25,
                      border: `1px solid ${BORDER}`,
                      borderRadius: "7px",
                      outline: "none",
                      backgroundColor: "#FFFFFF",
                      color: establishmentyear ? "#243746" : "#94A3B8",
                      fontSize: 13.5,
                      fontFamily: "inherit",
                      "&:focus": {
                        borderColor: NAVY,
                        boxShadow: "0 0 0 2px rgba(18,59,93,0.08)",
                      },
                    }}
                  >
                    <option value="">Select Year</option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </Box>
                  {errors.establishmentyear && (
                    <Typography
                      sx={{
                        mt: 0.45,
                        fontSize: 11,
                        color: ERROR,
                      }}
                    >
                      {errors.establishmentyear}
                    </Typography>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Field
                  label="Contact"
                  required
                  value={contact}
                  placeholder="Contact"
                  error={errors.contact}
                  onChange={(e) => {
                    setcontact(e.target.value);
                    setValidation(false);
                  }}
                  onMouseDown={() => setValidation(true)}
                  onFocus={() => handleFocus("contact")}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Field
                  label="Email ID"
                  required
                  value={emailid}
                  placeholder="E-Mail"
                  error={errors.emailid}
                  onChange={(e) => {
                    setEmailid(e.target.value);
                    setValidation(false);
                  }}
                  onMouseDown={() => setValidation(true)}
                  onFocus={() => handleFocus("emailid")}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Field
                  label="Trust"
                  value={trust}
                  placeholder="Trust"
                  error={errors.trust}
                  onChange={(e) => {
                    setTrust(e.target.value);
                    setValidation(false);
                  }}
                  onMouseDown={() => setValidation(true)}
                  onFocus={() => handleFocus("trust")}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Field
                  label="Organization Type"
                  value={type}
                  placeholder="Organization Type"
                  error={errors.type}
                  onChange={(e) => {
                    setType(e.target.value);
                    setValidation(false);
                  }}
                  onMouseDown={() => setValidation(true)}
                  onFocus={() => handleFocus("type")}
                />
              </Grid>
            </Grid>
          </Section>

          <Section
            icon={<CloudUploadOutlinedIcon fontSize="small" />}
            title="Organization Logo"
            subtitle="Upload a company logo up to 5 MB"
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "1fr 180px",
                },
                gap: 1.5,
                alignItems: "center",
              }}
            >
              <Box
                component="label"
                sx={{
                  minHeight: 92,
                  border: `1.5px dashed #B9CAD8`,
                  borderRadius: "9px",
                  display: "flex",
                  alignItems: "center",
                  gap: 1.25,
                  px: 1.5,
                  cursor: "pointer",
                  backgroundColor: "#FAFCFE",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#F3F8FC",
                    borderColor: "#8EA7BA",
                  },
                }}
              >
                <Box
                  sx={{
                    width: 42,
                    height: 42,
                    borderRadius: "9px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#EAF2F8",
                    color: NAVY,
                    flexShrink: 0,
                  }}
                >
                  <UploadFileOutlinedIcon />
                </Box>

                <Box
                  sx={{
                    minWidth: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 12.5,
                      fontWeight: 700,
                      color: "#33485C",
                    }}
                  >
                    {attachedFile ? attachedFile.name : "Choose logo file"}
                  </Typography>
                  <Typography
                    sx={{
                      mt: 0.3,
                      fontSize: 10.5,
                      color: MUTED,
                    }}
                  >
                    PNG, JPG or JPEG · Maximum 5 MB
                  </Typography>
                </Box>

                <Box
                  component="input"
                  type="file"
                  accept="image/*"
                  onChange={logoAction}
                  sx={{
                    display: "none",
                  }}
                />
              </Box>

              <Box
                sx={{
                  height: 92,
                  border: `1px solid ${BORDER}`,
                  borderRadius: "9px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#FFFFFF",
                  overflow: "hidden",
                }}
              >
                {logoPreview ? (
                  <Box
                    component="img"
                    src={logoPreview}
                    alt="Organization Logo"
                    sx={{
                      width: 76,
                      height: 76,
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      textAlign: "center",
                      color: "#A5B4C1",
                    }}
                  >
                    <ImageOutlinedIcon
                      sx={{
                        fontSize: 28,
                      }}
                    />
                    <Typography
                      sx={{
                        mt: 0.2,
                        fontSize: 10,
                      }}
                    >
                      Preview
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Section>

          <Divider />

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              py: 0.5,
              flexWrap: "wrap",
            }}
          >
            {mode === "U" && (
              <Button
                variant="contained"
                startIcon={<CloudUploadOutlinedIcon />}
                onClick={handleUpload}
                disabled={!attachedFile || loading}
                sx={{
                  minWidth: 105,
                  minHeight: 38,
                  borderRadius: "7px",
                  textTransform: "none",
                  fontSize: 12.5,
                  fontWeight: 700,
                  backgroundColor: NAVY,
                  "&:hover": {
                    backgroundColor: NAVY_DARK,
                  },
                }}
              >
                Upload
              </Button>
            )}

            <Button
              variant="contained"
              onClick={handlesubmit}
              disabled={loading}
              sx={{
                minWidth: 90,
                minHeight: 38,
                borderRadius: "7px",
                textTransform: "none",
                fontSize: 12.5,
                fontWeight: 700,
                backgroundColor: SUCCESS,
                "&:hover": {
                  backgroundColor: "#1C7E4E",
                },
              }}
            >
              Save
            </Button>

            <Button
              variant="contained"
              onClick={clearFields}
              disabled={loading}
              sx={{
                minWidth: 90,
                minHeight: 38,
                borderRadius: "7px",
                textTransform: "none",
                fontSize: 12.5,
                fontWeight: 700,
                backgroundColor: "#D74343",
                "&:hover": {
                  backgroundColor: "#BF3737",
                },
              }}
            >
              Reset
            </Button>
          </Box>
        </Box>
      </Box>

      {loading && <CustomLoader />}
    </>
  );
};

export default Oraganization;
